"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATION_TRAIN_DEFECT_ICON_TYPES = void 0;
exports.STATION_TRAIN_DEFECT_ICON_TYPES = [
    "bearing",
    "imbalance",
    "fan",
    "coupling",
    "belt",
    "gears",
    "electrical",
    "oil",
    "temperature",
    "other",
];
//# sourceMappingURL=station-tile-defect-icons.js.map